/* PRC site-wide JS for InstroTek.
   Loaded once from layout/theme.liquid. Uses event delegation so it
   doesn't care when DOM is added/swapped (Shopify customizer reloads
   blocks on save). */

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-prc-readmore-toggle]');
  if (!toggle) return;

  const wrapper = toggle.closest('[data-prc-readmore]');
  if (!wrapper) return;

  const expanded = wrapper.classList.toggle('is-expanded');
  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

  const moreLabel = toggle.querySelector('[data-prc-readmore-more]');
  const lessLabel = toggle.querySelector('[data-prc-readmore-less]');
  if (moreLabel) moreLabel.hidden = expanded;
  if (lessLabel) lessLabel.hidden = !expanded;
});
